import styled from 'styled-components';

export const LobbyPageStyle = styled.main`
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;
